import React from "react";

const FourOhFour = () => {
  return <h1>404</h1>;
};

export default FourOhFour;
